import service from './api.services';

const buscarEtapaIARA = async (idProcesso) => {
    const response = await service.get(`/api/etapa-iara/${idProcesso}`);
    return response.data;
};

const salvar = async (idProcesso, etapaIARA) => {
    const response = await service.post(`/api/etapa-iara/${idProcesso}`, etapaIARA);
    return response.data;
};

export {
    buscarEtapaIARA,
    salvar
};
